module.exports = __webpack_public_path__ + "img/computer-speaker.59e2f4c8.svg";